const GOOGLE_SHEETS_EDIT_BASE = 'https://docs.google.com/spreadsheets/d';

export function getGoogleSpreadsheetEditUrl(spreadsheetId: string): string {
	return `${GOOGLE_SHEETS_EDIT_BASE}/${spreadsheetId}/edit`;
}

/** Prefer an explicit URL from the API or picker when present; otherwise build the standard edit URL. */
export function resolveGoogleSpreadsheetEditUrl(spreadsheetId: string, knownUrl?: string | null): string {
	const trimmed = knownUrl?.trim();
	if (trimmed) return trimmed;
	return getGoogleSpreadsheetEditUrl(spreadsheetId);
}
